import { createSlice } from '@reduxjs/toolkit';

const jobsSlice = createSlice({
    name: 'jobs',
    initialState: { jobs: {}, events: {} },
    reducers: {
        addJob(state, { payload: { id, label } }) {
            state.jobs[id] = { label, status: 'pending' };
        },
        resolveJob(state, { payload: { id, status = 'done' } }) {
            if (state.jobs[id]) state.jobs[id].status = status;
        },
        dismissJob(state, { payload: id }) {
            delete state.jobs[id];
        },
        receiveJobEvent(state, { payload: { key, event } }) {
            state.events[key] = event;
        },
        clearJobEvent(state, { payload: key }) {
            delete state.events[key];
        },
    },
});

export const { addJob, resolveJob, dismissJob, receiveJobEvent, clearJobEvent } = jobsSlice.actions;
export const selectJobs = (state) => state.jobsSlice.jobs;
export const selectJobEvent = (key) => (state) => state.jobsSlice?.events?.[key] ?? null;
export default jobsSlice.reducer;
